const namespaced = true

const state = {
  list: [],
  list_loaded: false,
  item: null,
  selected: null,
  selects: [],
  is_ordered: false,
}

const getters = {
  list: (state) => state.list,
  list_loaded: (state) => state.list_loaded,
  item: (state) => state.item,
  selected: (state) => state.selected,
  selects: (state) => state.selects,
  is_ordered: (state) => state.is_ordered,
}

const mutations = {
  index: (state, payload) => {
    state.list_loaded = true
    state.list = payload.length ? payload : []
  },
  setItem: (state, payload) => {
    console.log(payload)
    state.item = payload
  },
  setSelected: (state, payload) => {
    state.selected = payload
  },
  setSelects: (state, payload) => {
    state.selects = payload
  },
  setOrderedStatus: (state) => {
    state.is_ordered = true
  },
}

const actions = {
  index: ({ commit }) => {
    axios.get('/api/shop-card/').then(({ data }) => {
      commit('index', data)
    })
  },
  store: ({ commit }, payload) => {
    return new Promise(resolve => {
      axios.put('/api/shop-card/', { shop_card: payload }).then(({ data }) => {
        commit('index', data)
      }).finally(() => resolve())
    })

  },
}

export default {
  mutations,
  actions,
  state,
  getters,
  namespaced,
}
